(function () {
  var ROOT_SELECTOR = '[data-cart-drawer]';
  var OPEN_CLASS = 'cart-drawer--open';

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('cart-drawer-lock', lock);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeDrawer();
  }

  function openDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.add(OPEN_CLASS);
    lockScroll(true);
    var panel = root.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove(OPEN_CLASS);
    lockScroll(false);
    document.removeEventListener('keydown', onKeydown);
  }

  function updateHeaderCount(count) {
    var link = document.querySelector('.header-cart');
    if (!link) return;
    var bubble = link.querySelector('.cart-count');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count';
        link.appendChild(bubble);
      }
      bubble.textContent = count;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function refreshDrawer(openAfter) {
    var url = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'sections=cart-drawer';
    return fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector(ROOT_SELECTOR);
        var currentRoot = getRoot();
        if (!newRoot || !currentRoot) return;
        currentRoot.querySelector('#CartDrawer-Content').innerHTML = newRoot.querySelector('#CartDrawer-Content').innerHTML;
        updateHeaderCount(parseInt(newRoot.getAttribute('data-cart-count') || '0', 10));
        if (openAfter) openDrawer();
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function () { return refreshDrawer(false); });
  }

  function quickAdd(variantId, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) { return response.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function () { if (btn) btn.disabled = false; });
  }

  function addToCart(form) {
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function () { return refreshDrawer(true); });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-toggle]')) {
      event.preventDefault();
      refreshDrawer(true);
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    var quickAddBtn = event.target.closest('[data-cart-drawer-quick-add]');
    if (quickAddBtn) {
      event.preventDefault();
      quickAdd(quickAddBtn.getAttribute('data-variant-id'), quickAddBtn);
      return;
    }
    var qtyBtn = event.target.closest('[data-cart-drawer-qty]');
    if (qtyBtn) {
      event.preventDefault();
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var quantity = Math.max(0, parseInt(qtyBtn.getAttribute('data-quantity'), 10));
      var item = qtyBtn.closest('.cart-drawer__item');
      if (item) item.classList.add('cart-drawer__item--loading');
      changeLine(line, quantity);
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-duo-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var box = select.closest('.cart-drawer__duo-box');
    if (!box || !option) return;
    var btn = box.querySelector('[data-cart-drawer-quick-add]');
    var priceWrap = box.querySelector('[data-duo-price]');
    if (!option.value) {
      if (btn) { btn.disabled = true; btn.removeAttribute('data-variant-id'); }
      if (priceWrap) priceWrap.hidden = true;
      return;
    }
    var img = box.querySelector('[data-duo-image]');
    if (img && option.getAttribute('data-image')) img.src = option.getAttribute('data-image');
    var media = box.querySelector('[data-duo-media]');
    if (media) media.classList.remove('cart-drawer__duo-box-media--empty');
    var compare = box.querySelector('[data-duo-compare]');
    if (compare) compare.textContent = option.getAttribute('data-compare');
    var half = box.querySelector('[data-duo-half]');
    if (half) half.textContent = option.getAttribute('data-half');
    if (priceWrap) priceWrap.hidden = false;
    if (btn) { btn.disabled = false; btn.setAttribute('data-variant-id', option.value); }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      event.preventDefault();
      addToCart(form);
    }
  });

  window.NamourouCartDrawer = { refresh: refreshDrawer, open: openDrawer };
})();
